import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { CustomerProfileDetailModel } from '../../../models/customer';
import { CustomerService, AccountService } from '../../../services';
import { AppUtils } from '../../../helpers';


@Component({
    selector: 'user-profile-detail',
    templateUrl: './profile.detail.component.html'
})

export class ProfileDetailComponent implements OnInit {
    @BlockUI('conatiner-profile') blockUI: NgBlockUI;

    constructor(private vcr: ViewContainerRef,
        private router: Router,
        private toastr: ToastsManager,
        private customerService: CustomerService,
        private accountService: AccountService,
        private appUtils: AppUtils) {
        this.toastr.setRootViewContainerRef(this.vcr);
    }

    model: CustomerProfileDetailModel = new CustomerProfileDetailModel();

    ngOnInit() {
        this.loadProfile();
    }

    loadProfile() {
        this.blockUI.start();
        this.customerService.getProfile()
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    Object.assign(this.model, data);
                    this.model.dateOfBirth = this.appUtils.getFormattedDate(this.model.dateOfBirth, null);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    changeRole(role: string) {
        if (role === this.model.role) {
            return;
        }

        if (!confirm('Are you sure you want to change the account type?')) {
            return;
        }
        this.blockUI.start();
        this.accountService.changeRole(role)
            .subscribe(
                () => {
                    this.router.navigate(['/account/logout']);
                    setTimeout(() => {
                        this.toastr.success('Your account type has been changed successfully. Please login again to continue.');
                    }, 100);
                }, error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    deactivate() {
        if (!confirm('Are you sure you want to deactivate your account?')) {
            return;
        }
        this.blockUI.start();
        this.accountService.deactivate()
            .subscribe(
                () => {
                    this.router.navigate(['/account/logout']);
                    setTimeout(() => {
                        this.toastr.success('Your account type has been deactivated successfully.'
                            + 'Please contact to administrator in case you want reactivate it again.');
                    }, 100);
                }, error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/profile-detail/profile.detail.component.ts